export default {
    data() {
        return {
            selectType:"",// 当前选择的历史记录类型

        }
    },
    methods: {
        
    },
}